import { twMerge } from "tailwind-merge";

const ArrowDown = ({ className, ...props }) => {
  return (
    <div className={twMerge("py-1", className)} {...props}>
      <svg
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2L6 6L10 2"
          stroke="#011D31"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default ArrowDown;
